import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Grid, Typography, Avatar } from '@mui/material';

const WidgetDescriptionV2 = ({
  title,
  description,
  icon,
  avatarClassName,
  rootStyle,
  avatarStyle,
}) => (
  <Card
    sx={{
      height: '100%',
      boxShadow:
        '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)',
      borderRadius: 1,
      border: (theme) => `0.5px solid ${theme.palette.neutral[800]}`,
      ...rootStyle,
    }}
  >
    <CardContent>
      <Grid container justifyContent="space-between">
        <Grid item>
          <Typography
            sx={{ fontWeight: 700 }}
            color="text.secondary"
            gutterBottom
            variant="body2"
          >
            {title}
          </Typography>
          <Typography variant="h3">{description}</Typography>
        </Grid>
        <Grid item>
          <Avatar
            sx={{
              bgcolor: 'primary.main',
              color: 'primary.contrastText',
              height: 56,
              width: 56,
            }}
            className={avatarClassName}
            style={avatarStyle}
          >
            {icon}
          </Avatar>
        </Grid>
      </Grid>
    </CardContent>
  </Card>
);

WidgetDescriptionV2.propTypes = {
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired,
  avatarClassName: PropTypes.node,
  rootStyle: PropTypes.object,
  avatarStyle: PropTypes.object,
};

WidgetDescriptionV2.defaultProps = {
  avatarClassName: null,
  rootStyle: {},
  avatarStyle: {},
};

export default WidgetDescriptionV2;
